import React, { Component } from "react";

import BookListDetailAudioBook from "./BookListDetailAudioBook";
import MyActivityList from "./MyActivityList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class lendBook extends Component {

	constructor(props) {
		super(props);

		this.state = { marktype: props.marktype};
    }

    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
	let struserid = cookie.load("general_userid");
        let struserdbid = cookie.load("general_userdbid");

        this.logPageView();

	let servicetype="40";
    let qtm= (new Date()).getTime();
	let params= "pgidx=0&pgsize=100&orderby=1&orderway=1&servicetype="+servicetype+"&marktype="+this.state.marktype+"&userdbid="+struserdbid+"&qrtime="+qtm;
	let content2= <BookListDetailAudioBook fetchurl={`/api/AB/BookMarkList?${params}`}  struserid={struserid} struserdbid={struserdbid} from_page={"audiobook"} />;


		return (
			<React.Fragment>
				<div className="section">
					
					<div className="section-body">
	    {content2}
					</div>
				</div>
			</React.Fragment>
		);
	}
	}

export default lendBook;
